<template>
    <div id="listRate">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Email Report</div>
                        <!-- Button for Clear Cache -->
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <a href="javascript:void(0)" class="btn btn-primary pull-right" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content email-report-list">
                        <data-table-filter-config :moduleName="'emailReports'" ref="filterEmailreport" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'emailReports'" :position="'top'">
                                  </custom-pagination>
                                  <vue-good-table
                                          ref="listEmailReport"
                                          mode="remote"
                                          @on-page-change="onPageChange"
                                          @on-sort-change="onSortChange"
                                          @on-column-filter="onColumnFilter"
                                          @on-selected-rows-change="selectionChanged"
                                          @on-per-page-change="onPerPageChange"
                                          @on-select-all="onSelectAll"
                                          :totalRows="totalRecords"
                                          title="Emails"
                                          :columns="userColumns"
                                          :rows="rows"
                                          :paginate="true"

                                          :paginationOptions="{
                                              enabled: false,
                                              position: 'both',
                                              perPage: perPage,
                                              perPageDropdown:dropDownPerPage,
                                              dropdownAllowAll: false,
                                          }"
                                          :select-options="{
                                          enabled: emailReport,
                                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                          selectionInfoClass: 'custom-class',
                                          selectionText: 'rows selected',
                                          clearSelectionText: 'clear',
                                      }"
                                          :sort-options="{
                                              enabled: true,
                                          }"
                                      >
                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'">
                                                  <template v-if="canViewEmailContent && props.row.type !== 'Customer Refund'">
                                                      <a href="javascript:void(0)" title="View" class="fp-view" v-on:click="viewMailTemplate(props.row.id)"></a>
                                                  </template>
                                              </div>
                                              <div v-else>
                                                  <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                              </div>
                                          </div>
                                      </template>
                                      <div slot="selected-row-actions">
                                          <button id="send" v-on:click.prevent="cancelEmail()" class="btn btn-primary">Delete</button>
                                          <button id="print" v-on:click.prevent="printStatement()" class="btn btn-primary">Download</button>
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                    <div class="modal fade invoice-modal" id="invoice_modal" ref="invModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                        <div :class="`loader${loaderClass}`" v-show="modalLoading">

                        </div>
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content notice-modal">
                                <div class="modal-header">
                                    <h5 class="modal-title">Email Content</h5>
                                    <h5 class="pull-right" id='sent_date'></h5>
                                </div>
                                <div class="mailBody p-3">
                                    TO: &nbsp;<span id='toMail' class="font-semibold"></span><br>
                                    CC: &nbsp;<span id="ccMail" class="font-semibold"></span>
                                </div>
                                <div class="modal-body">

                                </div>
                                <div class="mailBody p-3">
                                &nbsp;<a href="javascript:void(0)" id="fileLink" v-on:click="previewDocument()"><span class="fileupload-preview wrappath" style="color:blue;" id="fileName"></span></a>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-tertiary" data-dismiss="modal" ><i class="fp-close"> </i>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    
    
    import EventBus from "./event-bus";


    import {commonMixins} from '../mixins/commonMixins';
    import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "sentemail",
        metaInfo() {
            return {
                title: "Email Report | " +process.env.COPYRIGHT_NAME
            }
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
             permissions: [],
            cantAccessPage: "",
            firstLoad : 0,
            userColumns:[],
            emailReport:true,
            columns: [
                {
                    label: 'Action',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Received By',
                    field: 'sent_to',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Sent To", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'To',
                    field: 'email',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Email", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },
                {
                    label: 'CC',
                    field: 'cc',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "CC", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },
                {
                    label: 'Sent By',
                    field: 'created_by',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    html: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Sent By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Type',
                    field: 'type',
                    fpFieldType:"option",
                    hidden:false,
                    html: false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    hidden:false,
                    html: false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Queued', 'Sent','Opened','Failed'], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Sent Date',
                    field: 'updated_at',
                    fpFieldType:"date",
                    hidden:false,
                    html: false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },


            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            modalLoading:false,
            fileName:'',
            workOrdeEstimatePath:'',
            googleUrl:'',
            canViewEmailContent:false,
            action:'list',
            loggedInUser:0,
            pageKey:"_email_report_list_",
            batchProcess:0,
            batchNum:"",
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'email_report') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'view_email_content') {
                            self.canViewEmailContent = true;
                        }
                    }
                }

            }
        },
        created: function() {
            this.serverParams.sort = { field: "updated_at", type: "desc"};
        },
        mounted: function () {

            var self = this;

            self.getPermissions();
            this.workOrdeEstimatePath = process.env.FOLDER_URL + "/workorder-estimate/"
            this.googleUrl = "https://docs.google.com/viewerng/viewer?url=";

            var userJson = null;
            var userObj = localStorage.getItem("user_obj");
            //if user logged in than remove login button and registration button
            if ( userObj != null ) {
                userJson = JSON.parse(userObj);
                self.loggedInUser = userJson.id;
            }

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listEmailReport.unselectAllInternal();
            },
            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
            },
            exportCheck: function() {
                var self = this;
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['listEmailReport'].selectedRows;
                count = data.length;

                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }

                this.exportReports(actionFlag);
            },

            viewMailTemplate(id){

                var self = this;

                $("#invoice_modal .modal-body").html("");
                $("#invoice_modal").modal("show");
                self.modalLoading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/invoice-notice/template",
                    type: "POST",
                    data: {id:id,
                    flag:'sent_mail'},
                    headers: this.ajxHeaders,
                    success: function (data) {

                        $("#invoice_modal .modal-body").html("");

                        $('#toMail').text(data.to);
                        if(data.cc){
                            $('#ccMail').text(data.cc);
                        }else{
                            $('#ccMail').text('-');
                        }

                        $("#invoice_modal .modal-body").html(data.view);
                        $('#sent_date').text(data.sent_at);
                        //file name in case of estimate
                        if(data.filename){
                            self.fileName = data.filename;
                            $('#fileName').text(data.filename);
                        }else{
                            self.fileName = '';
                            $('#fileName').text('');
                        }
                        if(data.filepath){
                            self.workOrdeEstimatePath = data.filepath;
                        }
                        self.modalLoading = false;
                        // self.send_date = data;

                        setTimeout(function(){
                            $( "#captureReading" ).click(function() {

                                var dataId = $(this).attr("data-id");

                                if (dataId.includes('=')){
                                    var param = dataId.split('=');
                                    var params = atob(param[1]);
                                    var reminderId = 0;
                                    var emailReportId = 0;
                                    console.log(params)
                                    // var paramsArr = params.split("=");
                                    // self.reminderId = paramsArr[1];
                                    var paramsArr = params.split("&");
                                    for ( var i=0; i<paramsArr.length; i++ ) {
                                        var arr = paramsArr[i].split("=");

                                        if ( arr[0] == "readingReminderId" ) {
                                            reminderId = arr[1];
                                        }
                                        if ( arr[0] == "emailReportId" ) {
                                            emailReportId = arr[1];
                                        }
                                    }

                                    var url = process.env.RENTAL_URL+'add-reading?params='+btoa('readingReminderId='+reminderId+'&emailReportId='+emailReportId+'&userId='+self.loggedInUser);

                                    window.open(url,'_blank');

                                }
                            });
                        },100);

                    },
                    error: function (jqXHR, exception) {
                        self.modalLoading = false;
                        self.reqeustSent = 0;
                        self.generateStatusCodeMessage(jqXHR,true,'email-report-invoice-template');
                    }
                });

            },
            printStatement:function(){
                var data = this.$refs['listEmailReport'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listEmailReport'].selectedRows[i].id)
                }

                $.ajax({
                    url: process.env.ROOT_API + "/statement-pdf/download",
                    type: "POST",
                    data: {ids:use},
                    headers: this.ajxHeaders,
                    success: function (data) {
                        if (data.status == 'success'){
                            var link = document.createElement('a');
                            document.body.appendChild(link);
                            link.href = data.content;
                            link.download = '';
                            link.target = "_blank";
                            link.click();
                            self.cancelAll(true);
                        }
                        self.loadList();
                    },
                    error: function (jqXHR, exception) {
                        self.modalLoading = false;
                        self.reqeustSent = 0;
                        self.generateStatusCodeMessage(jqXHR,true,'email-report-invoice-template-download');
                    }
                });

            },
            // updateParams(newProps) {
            //     this.serverParams = Object.assign({}, this.serverParams, newProps);
            // },
            // onPageChange(params) {
            //     this.updateParams({page: params.currentPage});
            //     this.loadEmailReport();
            // },
            // onPerPageChange(params) {
            //     this.updateParams({perPage: params.currentPerPage});
            //     this.totalRecords = self.totalRecords;
            //     this.loadEmailReport();
            // },

            // onColumnFilter(params) {
            //     this.updateParams(params);
            //     {
            //         field:('sent_to');
            //         field:('email');
            //         field:('type');
            //         field:('status');
            //         field:('updated_at');
            //         field:('created_by');
            //     };
            //     var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
            //     var filters = filtersPr.columnFilters;
            //     if (this.firstLoad == 1 || filters.sent_to || filters.email || filters.type || filters.status || filters.updated_at || filters.created_by ) {
            //         this.loadEmailReport();
            //     }
            // },
            // selectionChanged() {
            //     var self = this;
            //     // console.log(self.computed.selectedRows);
            //     // var rowData = self.$refs['my-table'].selectedRows;
            //     // console.log(rowData);
            // },
            // onSortChange(params) {
            //     this.updateParams({
            //         sort: {
            //             type: params[0].type,
            //             field: params[0].field,
            //         },
            //     });
            //     this.loadEmailReport();
            // },

            loadList(){

                var data = this.$refs['listEmailReport'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listEmailReport'].selectedRows[i].id)
                }
                self.loading = true;
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/report/emails",
                    type: "POST",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        sort: self.serverParams.sort,
                        action:self.action,
                        all:self.serverParams.selectedAll,
                        id:use
                    },
                    success: function (data) {
                        self.loading = false;
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {

                            if (self.action == 'delete'){
                                self.action = 'list';
                                if ( data.code == 201 ){

                                    self.$swal('','Emails with status Queued can be removed','info');
                                } else {

                                    self.$swal('','Emails with status Queued can be removed','success');
                                }
                                self.$refs.filterEmailreport.clearSelectAll();

                                EventBus.$emit('clear-all-flags', false);
                                self.cancelAll(true);
                                self.loadList();
                            }else if ( self.action == "export" ||  self.action == "export_queue") {
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                                self.loadList();
                                return;

                            }else{

                                self.rows = data.content.row;

                                // self.perPage = data.content.perPage;
                                // if (data.content.totalRecords == 0){
                                //     self.rows = 0;
                                // }
                                self.totalRecords = data.content.totalRecords;
                            }


                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'email-report-list');
                    }
                });
            },

            cancelEmail() {

                var data = this.$refs['listEmailReport'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listEmailReport'].selectedRows[i].id)
                }
                 self.$swal({
                    title: 'Are you sure that you want to delete this Record?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                       self.action = 'delete';
                       self.loadList();

                    } else {
                      console.log("no");
                    }
                });
                
            },
            //preview document in case of estimate
            previewDocument(){
                var self = this;
                var file = "";
                var fileExtension = self.fileName.split('.').pop();
                // if(fileExtension && (fileExtension == 'png' || fileExtension == 'jpeg' || fileExtension == 'jpg')){
                    file = self.workOrdeEstimatePath + self.fileName;
                // }else{
                //     file =  self.googleUrl + self.workOrdeEstimatePath + self.fileName;
                // }

                var save = document.createElement('a');
                save.href = file;
                save.download = file;
                save.target = '_blank';
                document.body.appendChild(save);
                save.click();
                document.body.removeChild(save);
            }
        }
    };
</script>





// WEBPACK FOOTER //
// src/components/EmailsReport.vue